import { useQueryClient } from '@tanstack/react-query';
import { useAxiosConfig } from '../../AxiosConfigProvider';
import { useAppAccountOrganisationPartialUpdate } from '../../lib/app/app';
import {
  useCompanyReportsValidReportingYearsRetrieve,
  useOrganizationTimePeriodsList,
} from '../../lib/company-reports/company-reports';
import { ReportingYear, TimePeriod } from '../../types';

export const useGetValidReportingPeriods = () => {
  return useCompanyReportsValidReportingYearsRetrieve<ReportingYear[]>({
    request: useAxiosConfig(),
    query: {
      staleTime: 86400000, // 1 day
    },
  });
};

export const useGetTimePeriods = () => {
  return useOrganizationTimePeriodsList<TimePeriod[]>({
    request: useAxiosConfig(),
    query: {
      staleTime: 86400000, // 1 day
    },
  });
};

export const useSetOrganizationReportingPeriod = () => {
  const queryClient = useQueryClient();
  return useAppAccountOrganisationPartialUpdate({
    request: useAxiosConfig(),
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['account']);
      },
    },
  });
};
